// @flow
import { NotificationMessage } from 'bench-internal-theme';
import { Query } from '@apollo/client/react/components';
import React from 'react';
import { WrappedSpinner } from 'spinner';

import { GET_ASSIGNED_PERSONS } from './queries';
import UserAssignments from './UserAssignments';

type UserAssignmentsContainerProps = {
  clientId: string,
  onClientUpdate?: () => any,
};

const UserAssignmentsContainer = ({ clientId, onClientUpdate }: UserAssignmentsContainerProps) => (
  <Query query={GET_ASSIGNED_PERSONS} variables={{ clientId }}>
    {(queryResult: any) => {
      const { data, error, loading } = queryResult;
      if (loading) {
        return <WrappedSpinner />;
      }
      if (error) {
        return (
          <NotificationMessage styleType="error">
            Failed to fetch the client’s user assignments data. The error was: {error.message}
          </NotificationMessage>
        );
      }
      const { attachedPersons, principalPerson } = data.client;
      return (
        <UserAssignments
          attachedPersons={attachedPersons}
          clientId={clientId}
          onClientUpdate={onClientUpdate}
          principalPerson={principalPerson}
        />
      );
    }}
  </Query>
);

UserAssignmentsContainer.defaultProps = {
  onClientUpdate: undefined,
};

export default UserAssignmentsContainer;
